<template>
  <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Path</title>
      <defs>
          <filter id="filter-1">
              <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
          </filter>
      </defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-338.000000, -413.000000)">
              <g transform="translate(57.000000, 348.000000)" filter="url(#filter-1)">
                  <g transform="translate(285.000000, 72.000000) scale(1, -1) translate(-285.000000, -72.000000) translate(281.000000, 65.000000)">
                      <path d="M4.79578947,10.0995843 C4.64048081,10.2402767 4.42977644,10.3194092 4.21,10.3195843 L3.79,10.3195843 C3.57070017,10.3172802 3.36084904,10.2384682 3.20421053,10.0995843 L-2.46578947,4.95958425 C-2.57040962,4.86570095 -2.62925697,4.73790302 -2.62925697,4.60458425 C-2.62925697,4.47126549 -2.57040962,4.34346755 -2.46578947,4.24958425 L-1.68105263,3.53958425 C-1.57918761,3.44552019 -1.43976229,3.39251282 -1.29421053,3.39251282 C-1.14865876,3.39251282 -1.00923344,3.44552019 -0.907368421,3.53958425 L4,7.98958425 L8.90736842,3.53958425 C9.01113417,3.44492793 9.15238452,3.39168509 9.29973684,3.39168509 C9.44708916,3.39168509 9.58833951,3.44492793 9.69210526,3.53958425 L10.4657895,4.24958425 C10.5704096,4.34346755 10.629257,4.47126549 10.629257,4.60458425 C10.629257,4.73790302 10.5704096,4.86570095 10.4657895,4.95958425 L4.79578947,10.0995843 Z" id="Path" fill="#000000" fill-rule="nonzero" transform="translate(4.000000, 6.855635) rotate(-90.000000) translate(-4.000000, -6.855635) "></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
</template>

<script>
export default {
  name: 'chevron-right'
}
</script>